const initialTrackersState = {
    tab: 0,
    type: null,
    loading: false,
    cardItems: null,
    tabsHeaders: null,
    tabsItems: null,
    currentReport: null,
    currentReportFilter: null,
    currentReportItems: null,
    currentReportMeta: null,
    mhbuReportsList: [],
    mhbuReportsMeta: null,
    trackersReportsList: [],
    trackersReportsMeta: null,
};

const Reports = {
    namespaced: true,
    state: {
        tab: initialTrackersState.tab,
        type: initialTrackersState.type,
        loading: initialTrackersState.loading,
        cardItems: initialTrackersState.cardItems,
        tabsHeaders: initialTrackersState.tabsHeaders,
        tabsItems: initialTrackersState.tabsItems,
        currentReport: initialTrackersState.currentReport,
        currentReportFilter: initialTrackersState.currentReportFilter,
        currentReportItems: initialTrackersState.currentReportItems,
        currentReportMeta: initialTrackersState.currentReportMeta,
        mhbuReportsList: initialTrackersState.mhbuReportsList,
        mhbuReportsMeta: initialTrackersState.mhbuReportsMeta,
        trackersReportsList: initialTrackersState.trackersReportsList,
        trackersReportsMeta: initialTrackersState.trackersReportsMeta,
    },
    mutations: {
        SET_TAB(state, tab) {
            state.tab = tab;
        },
        SET_TYPE(state, type) {
            _.set(state, 'type', type);
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_MHBU_REPORTS_LIST(state, list) {
            _.set(state, 'mhbuReportsList', list);
        },
        SET_MHBU_REPORTS_META(state, meta) {
            _.set(state, 'mhbuReportsMeta', meta);
        },
        SET_TRACKERS_REPORTS_LIST(state, list) {
            _.set(state, 'trackersReportsList', list);
        },
        SET_TRACKERS_REPORTS_META(state, meta) {
            _.set(state, 'trackersReportsMeta', meta);
        },
        SET_CURRENT_REPORT(state, report) {
            _.set(state, 'currentReport', report);
        },
        SET_CURRENT_REPORT_FILTER(state, filter) {
            _.set(state, 'currentReportFilter', filter);
        },
        SET_CURRENT_REPORT_ITEMS(state, items) {
            _.set(state, 'currentReportItems', items);
        },
        SET_CURRENT_REPORT_META(state, meta) {
            _.set(state, 'currentReportMeta', meta);
        },
        SET_CARD_ITEMS(state, items) {
            _.set(state, 'cardItems', items);
        },
        SET_TABS_ITEMS(state, items) {
            _.set(state, 'tabsItems', items);
        },
        SET_TABS_HEADERS(state, headers) {
            _.set(state, 'tabsHeaders', headers);
        },
    },
    actions: {
        changeTab({ commit }, tab) {
            commit('SET_TAB', tab);
        },
        setLoading({ commit }, loading) {
            commit('SET_LOADING', loading);
        },
        setCurrentReportFilter({ commit }, filter) {
            commit('SET_CURRENT_REPORT_FILTER', filter);
        },
        setCurrentReportItems({ commit }, items) {
            commit('SET_CURRENT_REPORT_ITEMS', items);
        },
        setCurrentReportMeta({ commit }, meta) {
            commit('SET_CURRENT_REPORT_META', meta);
        },
        setType({ commit, state }, type) {
            const currentReport = state.cardItems.find((x) => x.type === type);
            if (currentReport) {
                commit('SET_CURRENT_REPORT', currentReport);
            }
            commit('SET_TYPE', type);
        },
        setCardItems({ commit }, items) {
            commit('SET_CARD_ITEMS', items);
        },
        setTabsItems({ commit }, items) {
            commit('SET_TABS_ITEMS', items);
            const headers = items.map((x) => x.title);
            commit('SET_TABS_HEADERS', headers);
        },
        generateMhbuReport({ dispatch }, data) {
            return axios.post(route('api.v1.trackers.reports.mhbu.store', data)).then(() => {
                dispatch('fetchMhbuReportsList', new Object());
            });
        },
        fetchMhbuReportsList({ commit }, data) {
            let params = _.clone(data);
            params.limit = params.limit || 18;
            params.page = params.page || 1;
            params.sort = '-created_at';
            params.fields = 'id,file_name';
            return axios
                .get(route('api.v1.trackers.reports.mhbu.index'), {
                    params,
                })
                .then((response) => {
                    const reports = _.clone(response.data.data);
                    const meta = _.clone(response.data.meta);
                    commit('SET_MHBU_REPORTS_LIST', reports);
                    commit('SET_MHBU_REPORTS_META', meta);
                });
        },
        generateTrackersReport({ dispatch }, data) {
            return axios.post(route('api.v1.trackers.reports.trackers.store', data)).then(() => {
                dispatch('fetchTrackersReportsList', new Object());
            });
        },
        fetchTrackersReportsList({ commit }, data) {
            let params = _.clone(data);
            params.limit = params.limit || 18;
            params.page = params.page || 1;
            params.sort = '-created_at';
            params.fields = 'id,file_name';
            return axios
                .get(route('api.v1.trackers.reports.trackers.index'), {
                    params,
                })
                .then((response) => {
                    const reports = _.clone(response.data.data);
                    const meta = _.clone(response.data.meta);
                    commit('SET_TRACKERS_REPORTS_LIST', reports);
                    commit('SET_TRACKERS_REPORTS_META', meta);
                });
        },
    },
};

export default Reports;
